import React from 'react';
import {StyleSheet, css} from 'aphrodite';

const BioText = () => {
    return (
        <span className={css(styles.bioText)}>
            <h2 className={`text-left ${css(styles.textHeadline)}`}>Who am I ?</h2>
            <p className='text-left' >I am a full-stack web developer with a diverse background in logistics, music, and holistic medicine. 
            Yes! I do have an education in Traditional Chinese Medicine and I was a Licensed Acupuncturist once upon a time. I began my love 
            of web development while researching technologies to create a food blog and ecommerce web site. I started making html canvas animations
            and web based audio tools using the web audio api. My passion is to create great web experiences that are a joy to use and bring people together.
            </p>
            <h2 className={`text-left ${css(styles.textHeadline)}`}>What I do</h2>
            <p className='text-left'>React and Node. I build modern web applications using React for the front end and Node for the backend. 
            I have built applications on top of a REST api And a GraphQL api. I have built realtime applications on top of Socket.io. I am familiar with animation
            libraries like GSAP as well as more react centered animation libraries like react-spring and react-transition-group. I have used many 
            other packages for React and Node. I have built applications to crawl through other web pages and scrape data from them. I have built 
            applications using HTML5 video and the web audio api and the geolocation api. I have used Mongodb and MySQL for databases and i am familiar 
            with Firebase. I have delpoyed applications to old school shared servers, Heroku, as well as distributed apps in Docker containers in a 
            Kubernetes instance. I love play and create music. I love to eat good food. I love to talk about philosophy and life and I love my family and
            my friends. I really want to thank you for taking the time to look at my portfolio. If you would like to contact me for any reason head over
            to the contact section and drop me a line!</p>
        </span>
    )
}

const styles = StyleSheet.create({
    bioText: {
        fontFamily: "Lato",
        fontSize: "1.5em",
        color: '#ACAA9C',
        lineHeight: 1.6
    },
    textHeadline: {
        fontSize: '2.5em',
        fontFamily: 'Squada One',
        color: '#f5b779',
        '@media (max-width: 883px)': {
            fontSize: '1.25em'
        },
        '@media (max-width: 1104px)':{
            fontSize: '2em'
        }
    }
})

export default BioText;


// WEBPACK FOOTER //
// ./src/components/bio/bioText.js